module.exports = __webpack_public_path__ + "static/media/urbangoo12.072a1c2f.webp";